import { useNavigate } from "react-router-dom";
import club_logo from '../images/riverrun.png'
import { useContext, useState } from "react";
import { base_url } from '../url_variables';
import axios from 'axios';
import { GridLoader } from "react-spinners";
import { useCookies } from "react-cookie";
import { TostMessageContext } from "../context/TostMessage";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formFields, setFormFields] = useState({});
  const [cookies, setCookie, removeCookie] = useCookies();
  const [userProfile, setUserProfile] = useState({});
  const [errMsg, setErrMsg] = useState(null);
  const { setTostMessage } = useContext(TostMessageContext);
  const [initiatePasswordChange, setInitiatePasswordChange] = useState(false)

  const handleLogin = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("email", formFields?.email);
    formData.append("password", formFields?.password);
    formData.append("otp", formFields?.otp);

    try {
        const response = await axios.post(base_url + '/change-password.php', formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        if (response.data.status) {
            setTostMessage({
                messageType: "success",
                message: response.data.message,
            });
            setLoading(false);
            navigate("/");
        } else {
            setLoading(false);
            setErrMsg(response.data.message);
            setTostMessage({
                messageType: "error",
                message: response.data.message,
            });
        }
    } catch (error) {
        setLoading(false);
        setErrMsg('Network error');
        setTostMessage({
            messageType: "error",
            message: "Network error",
        });
    }
  };

  const getOtp = async () => {
    setLoading(true);
    setInitiatePasswordChange(false)
    const formData = new FormData();
    formData.append("email", formFields.email);

    try {
        const response = await axios.post(base_url + '/get-reset-email.php', formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        if (response.data.status) {
            setTostMessage({
                messageType: "success",
                message: response.data.message,
            });
            setLoading(false);
            setInitiatePasswordChange(true)
        } else {
            setLoading(false);
            setErrMsg(response.data.message);
            setTostMessage({
                messageType: "error",
                message: response.data.message,
            });
        }
    } catch (error) {
        setLoading(false);
        setErrMsg('Network error');
        setTostMessage({
            messageType: "error",
            message: "Network error",
        });
    }
  }

  return (
    <div className="flex flex-col gap-y-5 items-center justify-center min-h-screen bg-gray-50">
      <div className="bg-white p-6 rounded-lg shadow-md w-96 space-y-6">
        <div className='flex flex-col justify-start items-center w-full mt-[10px] mb-[10px]'>
            <img src={club_logo} className="h-[80px] mr-2" alt="logo" />
            <h2 className="text-center text-lg font-semibold mt-3">Reset Password</h2>
        </div>
        {errMsg != null && <div className="border border-1 border-[#ff0000] mb-[10px] bg-[#ffdede] py-2 rounded-[5px] flex items-center justify-center">
            <p className="text-[#d40000]">{errMsg}</p>
        </div>}
        <div className="flex flex-row justify-between">
            <input onChange={(e) => setFormFields({...formFields, email: e.target.value})} className="w-[70%] border p-2 rounded" placeholder="Email Address" />
            <button
                className="bg-primary h-full py-2 px-4 flex items-center justify-center text-white w-auto rounded hover:bg-secondary"
                onClick={getOtp}
            >
                Get OTP
            </button>
        </div>
        {initiatePasswordChange && 
            <div className="gap-y-3">
                <label>One-Time Code</label>
                <input autoComplete="off" autoCorrect="off" auto onChange={(e) => setFormFields({...formFields, otp: e.target.value})} className="my-1 w-full border p-2 rounded" type="default" placeholder="Enter One-Time Code" />
                <label>New Password</label>
                <input autoComplete="off" autoCorrect="off" onChange={(e) => setFormFields({...formFields, password: e.target.value})} className="my-1 w-full border p-2 rounded" type="default" placeholder="Enter New Password" />
            </div>
        }
        <button 
          className={`${initiatePasswordChange ? 'opacity-1' : 'opacity-[0.7]'} bg-primary h-[40px] flex items-center justify-center text-white w-full rounded hover:bg-secondary`}
          onClick={initiatePasswordChange ? handleLogin : null}
        >
          {loading ? (
                <GridLoader
                    color={'#ffffff'}
                    loading={loading}
                    size={5}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                />
                ) : 'Reset'
            }
        </button>
        <div className="flex flex-row mx-auto items-center justify-center">
          <a>Remember your password?</a><p onClick={() => navigate('/')} className="cursor-pointer ml-1 text-primary font-semibold font-aileron-regular">Login</p>
        </div>
      </div>
      <a href="https://riverrunresidence.com" className="underline text-sm font-aileron-regular cursor-pointer">Back to riverrunresidence.com</a>
    </div>
  );
}
